(function ($) {
    
    function arrowClicks(){
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header"><a href="/" class="sidr__logo">' + $('.site-logo .logo-img').html() + '</a><span class="sidr__close" aria-label="Close Menu"></span></div>';
                
                sidrHtml += '<div class="sidr__inner">';
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.site-header-contact-btn').length){
                    sidrHtml += '<div class="sidr__subnav">' + $('.site-header-contact-btn').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('.site-header').removeClass('sticky');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });

        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('sidr__menu-back').unbind();
        });
        
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });

	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    //on resize
//    $(window).on('resize', function(){
//        AOS.refresh();
//    });
//    $("#page").on('scroll', function () {
//        AOS.refresh();
//    });
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
    });
    
})(jQuery);